import { createSelector } from 'reselect';

const selector = state => {
  return state.reports.items.asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result
)



// WEBPACK FOOTER //
// ./src/selectors/reports-selector.js